/**
 * @typedef CustomCurrencyHtmlInputProperties
 * @property {() => void} __custom__format
 * @property {float} __custom__value
 */

/**
 * @typedef {CustomCurrencyHtmlInputProperties & HTMLInputElement} CustomCurrencyHtmlInput
 */

/**
 * @param {HTMLInputElement} inputElement
 * @param options
 *
 * @return {CustomCurrencyHtmlInput}
 */
function setAsCurrencyField(inputElement, options = {
	allowEmpty: false,
}) {
	const defaultOptions = {
		locale: 'en-US',
		intlOptions: {
			style: 'currency',
			currency: 'USD'
		}
	}

	const finalOptions = {
		...defaultOptions,
		...options,
	}


	inputElement.addEventListener('change', format);
	inputElement.addEventListener('keyup', format);

	// Add custom method to input so we can format it when manually changed
	// noinspection JSUndefinedPropertyAssignment
	inputElement.__custom__format = format;

	format();

	// Methods

	function format() {
		let originalValue = inputElement.value;

		// Remove everything but number and periods
		let cleanedUpValue = originalValue.replace(/[^\d.]/g, '');

		// Remove consecutive periods
		cleanedUpValue = cleanedUpValue.replace(/\.\.+/g, '');

		// Check if we allow empty and end early
		if (options.allowEmpty) {
			if (cleanedUpValue.trim() === '') {
				// Empty string, clear input and skip formatting
				// noinspection JSUndefinedPropertyAssignment
				inputElement.__custom__value = '';
				inputElement.value = ''

				return;
			}
		}

		// Parse as float
		let asFloat = parseFloat(cleanedUpValue);

		if (isNaN(asFloat)) {
			asFloat = 0;
		}

		// Preserve last period
		const preserveDecimals = /\.\d*/.exec(cleanedUpValue);

		// Format and replace on element
		let asCurrency = asFloat.toLocaleString(finalOptions.locale, finalOptions.intlOptions);

		// Remove decimal output from locale string function
		asCurrency = asCurrency.replace(/\.\d*/, '');

		if (preserveDecimals) {
			asCurrency += preserveDecimals[0].slice(0, 3);
		}

		// noinspection JSUndefinedPropertyAssignment
		inputElement.__custom__value = asFloat;
		inputElement.value = asCurrency
	}
}


export {setAsCurrencyField}
